import { render } from "./CheckMarkIcon.vue?vue&type=template&id=2e998f0e"
const script = {}
script.render = render

export default script